'use strict'

/**
 * @type {Array}
 * @description The available types of element we want to render
 * as a button
 */
export const types = ['a', 'router-link', 'RouterLink']
